(function () {
  'use strict';

  const closeModal = (modal) => {
    modal.style.display = "none";
    document.body.classList.remove("modal-active");
  }
  
  // Get the modal
  const modalData = (modalWrapper) => {
    var modal = document.querySelector('#myDynamicModal');
    var modalHeader = modalWrapper.querySelectorAll('.modal-header')[0].innerHTML;
    var modalBody = modalWrapper.querySelectorAll('.modal-body')[0].innerHTML;
    var modalFooter = modalWrapper.querySelectorAll('.modal-footer')[0].innerHTML;

    modal.querySelector('h2').innerHTML = modalHeader;
    modal.querySelector('.myDynamicModal-body').innerHTML = modalBody;
    modal.querySelector('h3').innerHTML = modalFooter;
    modal.style.display = "block";
    document.body.classList.add("modal-active");
    
    // When the user clicks anywhere outside of the modal, close it
    window.onclick = function(event) {
      if (event.target == modal) {
        closeModal(modal);
      }
    }

    // Get the <span> element that closes the modal
    var span = document.getElementsByClassName('myDynamicModalClose')[0];
    // When the user clicks on <span> (x), close the modal
    span.onclick = function() {
      closeModal(modal);
    }
  } 

  // Get all modal trigger buttons
  const modalBtns = document.querySelectorAll('.myDynamicModalBtn');
  modalBtns.forEach(modalBtn => {
    // When the user clicks the button, open the modal
    modalBtn.addEventListener('click', function(e){
      var modalWrapperID = document.getElementById(e.target.getAttribute('data-target'));
      modalData(modalWrapperID);
    });
  });
})();